import { getEnglishComparePageBySlug } from "@/app/seo-compare-en";
import { CompareLayoutEn } from "./CompareLayoutEn";

export default function EnglishHotlineVsMcp() {
  const page = getEnglishComparePageBySlug("hotline-vs-mcp");
  if (!page) return null;
  return <CompareLayoutEn page={page} />;
}
